import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hwdi-agile-development',
  templateUrl: './agile-development.component.html',
  styleUrls: ['./agile-development.component.scss']
})
export class AgileDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
